import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selectFields'
})
export class SelectFieldsPipe implements PipeTransform {

  transform(value: any[]): any {
    if (!value) {
      return [];
    }
    return value.map(a => { return { id: a.Id, text: a.Name || a.Title }; });
  }

}
